function updateFreeGiftOptions(currentVariant = null) {
    const freeGiftBlocks = document.querySelectorAll('.free-gifts-block .free-gift-product-main');

    if(!freeGiftBlocks.length || currentVariant === null) {
        console.log('No free gift blocks found on the page.');
        return;
    }

    freeGiftBlocks.forEach(block => {
        const optionName = block.getAttribute('data-option-name').split(',');
        const currentOptionToCheck = currentVariant.options.some(option => optionName.includes(option.toLowerCase()));
        const target = block.querySelector('.toggle-product');
        const freeGiftInput = document.querySelector(`input.free-gift-product-v-id[value="${block.getAttribute('data-v-id')}"]`);
        const onlyOnSubscribe = block.getAttribute('data-only-on-subscribe') === 'true';
        const currentlyOneTime = document.querySelector('input[name="selling_plan"]')?.hasAttribute('disabled') || true;

        if(currentOptionToCheck) {
            if(onlyOnSubscribe) {
                if(!currentlyOneTime){
                    target.classList.remove('inactive');
                    if(freeGiftInput) {
                        freeGiftInput.removeAttribute('disabled');
                    }
                }
            } else {
                target.classList.remove('inactive');
                if(freeGiftInput) {
                    freeGiftInput.removeAttribute('disabled');
                }
            }
        } else {
            target.classList.add('inactive');
            if(freeGiftInput) {
                freeGiftInput.setAttribute('disabled', 'disabled');
            }
        }
    });
}

// handle the one time purchase toggle
function handleOneTimeToggle(isOneTime = true) {
    const isMpc = document.querySelector('.mpc-bundle');

    if(!isMpc) return;
    
    if(isOneTime) {
        isMpc.classList.remove('subscribe-selected');
    } else {
        isMpc.classList.add('subscribe-selected');        
    }

    // update add-on product properties based on the selected variant
    const addOnProductProps = document.querySelectorAll('.add-on-product-prop');
    if(addOnProductProps.length > 0) {
        addOnProductProps.forEach(input => {
            input.value = `${Date.now()}`;
        });
    }
}

window.customOnVariantChange = function (currentVariant = null) {
    // active the free gift based on the selected variant
    updateFreeGiftOptions(currentVariant);

    // update the one time toggle saving percentage based on the selected variant
    const savingPercent = document.querySelector('.mpc-bundle fieldset.bundle-option input[type=radio]:checked+label .variant-price .saving-percentage.for-subscription');
    if(savingPercent) {
        const percentValue = savingPercent.getAttribute('data-percent');
        const savingPercentSpan = document.querySelector('.one-time-toggle .saving-percent');
        if(savingPercentSpan) {
            savingPercentSpan.textContent = `${percentValue}%`;
        }
    }

    // update add-on product properties based on the selected variant
    const addOnProductProps = document.querySelectorAll('.add-on-product-prop');
    if(addOnProductProps.length > 0) {
        addOnProductProps.forEach(input => {
            input.value = `${currentVariant.id}-${Date.now()}`;
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const oneTimeToggle = document.getElementById('one_time_toggle');
    const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
    const savingPercent = document.querySelector('.mpc-bundle fieldset.bundle-option input[type=radio]:checked+label .variant-price .saving-percentage.for-subscription');

    if(oneTimeToggle && sellingPlanInput) {
        oneTimeToggle.addEventListener('change', (event) => {
            const isOneTime = !event.target.checked;
            if(isOneTime) {
                sellingPlanInput.setAttribute('disabled', 'disabled');
            } else {
                sellingPlanInput.removeAttribute('disabled');
            }
            handleOneTimeToggle(isOneTime);
        });
    }

    if(savingPercent) {
        const percentValue = savingPercent.getAttribute('data-percent');
        const savingPercentSpan = document.querySelector('.one-time-toggle .saving-percent');
        if(savingPercentSpan) {
            savingPercentSpan.textContent = `${percentValue}%`;
        }
    }

    // initial check on page load
    const initialVariant = window.product_selected_variant || null;
    updateFreeGiftOptions(initialVariant);

});